export default "__VITE_ASSET__DfXzn498__"